import {
  colorCss,
  fontSizeCss,
  mobileColorCss,
  mobileFontSizeCss,
} from 'common/utils/styleUtilsNew'
import { css, styled } from 'styled-components'

export interface FormSuccessOptInScreenHeaderUiStylesInterface {
  fontSize?: number
  mobileFontSize?: number
  color?: string
  mobileColor?: string
}

export const FormSuccessOptInScreenHeaderUi = styled.h3<FormSuccessOptInScreenHeaderUiStylesInterface>`
  
  margin-top: 16px;

  word-break: break-word;

  ${fontSizeCss}
  ${colorCss}

  ${p => p.theme.phone} {

    ${mobileFontSizeCss}
    ${mobileColorCss}
  }
  ${p =>
    p.theme.isEditorMobileMode &&
    css`

    ${mobileFontSizeCss}
    ${mobileColorCss}
  `}
`
